import RestApiModel from "@/api/Model/RestApiModel";
import api from "@/api";

class CommercialProduct extends RestApiModel {
  static getResourceEndpoint() {
    return '/commercial-products';
  }

  static getDynamicProductsTypes() {
    return api.get(this.getResourceEndpoint() + '/dynamic-products-types');
  }

  static listByProducers({ params } = {}) {
    return api.get(this.getResourceEndpoint() + '/by-producer', { params });
  }

  static listProducers(params, id, withProducerStatus = false) {
    return api.get(this.getResourceIdEndpoint(id) + '/producers', { params: { withProducerStatus } });
  }

  static assignProducers(producerIds, id) {
    return api.post(this.getResourceIdEndpoint(id) + '/producers', { producerIds });
  }

  static getProductBundleTypes() {
    return api.get(this.getResourceEndpoint() + '/dynamic-bundle-types');
  }

  static addAlternativeCommercialProductTo(id, targetCommercialProductId) {
    return api.get(`${this.getResourceIdEndpoint(id)}/add-alternative-commercial-products/${targetCommercialProductId}`);
  }

  static getAlternativeCommercialProducts(id) {
    return api.get(`${this.getResourceIdEndpoint(id)}/alternative-commercial-products`);
  }

  static removeSelectedAlternativeCommercialProducts(id, alternativeCommercialProductsIds) {
    return api.post(this.getResourceIdEndpoint(id) + '/remove-alternative-commercial-products', { alternativeCommercialProductsIds });
  }
  
  static salesCountries() {
    return this.list({endpoint: this.getResourceEndpoint() + '/sales-countries'});
  }

  static getSalesCountry(id) {
    return api.get(this.getResourceIdEndpoint(id) + '/sales-country');
  }

  /**
   * @param id
   * @param isEnabled
   * @returns {*}
   */
  static enable(id, isEnabled) {
    return api.patch(`${this.getResourceIdEndpoint(id)}/enable`, { isEnabled });
  }

  static addCommercialProductToAllSalesCountry(id) {
    return api.post(`${this.getResourceIdEndpoint(id)}/add-to-all-sales-country`);
  }

  static updateExtraInfo(id, extraInfo) {
    return api.patch(`${this.getResourceIdEndpoint(id)}/extra-info`, { extraInfo });
  }

  static nodesList() {
    return api.get(this.getResourceEndpoint() + '/nodes');
  }
}

export default CommercialProduct;
